import { defineComponent as _defineComponent } from 'vue'
import sharedMessages from '@/lib/shared-messages';


export default /*#__PURE__*/_defineComponent({
  __name: 'BaseCardAction',
  props: {
  isSubmittable: {
    type: Boolean,
    required: false,
    default: false,
  },
  isDeletable: {
    type: Boolean,
    required: false,
    default: false,
  },
  valid: {
    type: Boolean,
    required: false,
    default: false,
  },
},
  emits: ["deactivate", "submit", "delete"],
  setup(__props, { emit: emits }: { emit: ({
  (e: 'deactivate'): void;
  (e: 'submit'): void;
  (e: 'delete'): void;
}), expose: any, slots: any, attrs: any }) {





const deactivate = (): void => {
  emits('deactivate');
};

const submit = (): void => {
  emits('submit');
};

const postDelete = (): void => {
  emits('delete');
};

return { __sfc: true,emits, deactivate, submit, postDelete, sharedMessages }
}

})